export const actionTypes: any = {
  // List
  GET_OAUTH_CLIENTS_REQUEST: 'GET_OAUTH_CLIENTS_REQUEST',
  GET_OAUTH_CLIENTS_SUCCESS: 'GET_OAUTH_CLIENTS_SUCCESS',
  GET_OAUTH_CLIENTS_FINISH: 'GET_OAUTH_CLIENTS_FINISH',

  // Create
  CREATE_OAUTH_CLIENT_REQUEST: 'CREATE_OAUTH_CLIENT_REQUEST',
  CREATE_OAUTH_CLIENT_SUCCESS: 'CREATE_OAUTH_CLIENT_SUCCESS',
  CREATE_OAUTH_CLIENT_FINISH: 'CREATE_OAUTH_CLIENT_FINISH',
  CREATE_OAUTH_CLIENT_RESET: 'CREATE_OAUTH_CLIENT_RESET',

  // Revoke
  REVOKE_OAUTH_CLIENT_REQUEST: 'REVOKE_OAUTH_CLIENT_REQUEST',
  REVOKE_OAUTH_CLIENT_SUCCESS: 'REVOKE_OAUTH_CLIENT_SUCCESS',
  REVOKE_OAUTH_CLIENT_FINISH: 'REVOKE_OAUTH_CLIENT_FINISH',

  // Delete
  DELETE_OAUTH_CLIENT_REQUEST: 'DELETE_OAUTH_CLIENT_REQUEST',
  DELETE_OAUTH_CLIENT_SUCCESS: 'DELETE_OAUTH_CLIENT_SUCCESS',
  DELETE_OAUTH_CLIENT_FINISH: 'DELETE_OAUTH_CLIENT_FINISH',

  // Tokens
  GET_OAUTH_TOKENS_REQUEST: 'GET_OAUTH_TOKENS_REQUEST',
  GET_OAUTH_TOKENS_SUCCESS: 'GET_OAUTH_TOKENS_SUCCESS',
  GET_OAUTH_TOKENS_FINISH: 'GET_OAUTH_TOKENS_FINISH',
}
